var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_16775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1043 4.97462C17.81 4.37333 21.0923 4.16666 25 4.16666C28.9077 4.16666 32.19 4.37333 34.8956 4.97462C37.625 5.58118 39.8934 6.61666 41.6384 8.36162C43.3834 10.1066 44.4188 12.375 45.0254 15.1043C45.6267 17.81 45.8334 21.0923 45.8334 25C45.8334 28.9077 45.6267 32.19 45.0254 34.8956C44.4188 37.625 43.3834 39.8933 41.6384 41.6383C39.8934 43.3833 37.625 44.4187 34.8956 45.0254C32.19 45.6267 28.9077 45.8333 25 45.8333C21.0923 45.8333 17.81 45.6267 15.1043 45.0254C12.3751 44.4187 10.1066 43.3833 8.36164 41.6383C6.61669 39.8933 5.58121 37.625 4.97465 34.8956C4.37335 32.19 4.16669 28.9077 4.16669 25C4.16669 21.0923 4.37335 17.81 4.97465 15.1043C5.58121 12.375 6.61669 10.1066 8.36164 8.36162C10.1066 6.61666 12.3751 5.58118 15.1043 4.97462ZM32.7231 19.3602C33.5367 20.1738 33.5367 21.4929 32.7231 22.3065L25.0506 29.979C23.8721 31.1575 21.9613 31.1575 20.7827 29.979L17.2769 26.4731C16.4633 25.6596 16.4633 24.3404 17.2769 23.5269C18.0905 22.7133 19.4096 22.7133 20.2232 23.5269L22.9167 26.2204L29.7769 19.3602C30.5904 18.5466 31.9096 18.5466 32.7231 19.3602Z",
    fill: "#27AE60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_16775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b99a40875f432780f47ae1807240de83.svg";
export { ForwardRef as ReactComponent };